import { FC, PropsWithChildren } from 'react'
import { Link } from '@inertiajs/react'
import cn from 'classnames'

type TProps = {
  href: string
  className?: string
} & PropsWithChildren

const FooterLink: FC<TProps> = ({ href, children, className = 'text-palette-grey--50' }) => {
  return (
    <Link
      href={href}
      className={cn(
        'font-body---16px py-2 font-medium transition-colors hover:text-palette-blue hover:no-underline focus:outline-none',
        className,
      )}
      preserveScroll={false}
    >
      {children}
    </Link>
  )
}

export { FooterLink }
